// extracted by mini-css-extract-plugin
export var button = "_fs-2";
export var card = "_fs-0";
export var closeButtonContainer = "_fs-3";
export var iconContainer = "_fs-1";